import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbCalendarInput as ClbCalendarInput_ } from '@celebration/design-system/dist/lib/calendar-input';
import { ClbCalendar as ClbCalendar_ } from '@celebration/design-system/dist/lib/calendar';
import { ClbDatePicker as ClbDatePicker_ } from '@celebration/design-system/dist/lib/date-picker';
const events = {
    onClbChangeInputDate: ClbCalendarInput_.events
        .onClbChangeInputDate,
    onClbClearInputDate: ClbCalendarInput_.events
        .onClbClearInputDate,
    onClbSelectDate: ClbCalendar_.events
        .onClbSelectDate,
    onClbChangeDate: ClbDatePicker_.events
        .onClbChangeDate,
};
export const ClbDatePicker = createComponent({
    tagName: ClbDatePicker_.tagName,
    elementClass: ClbDatePicker_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map